import React from "react";

const Arrow = () => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M0 9.5H20M20 9.5L11.5 1M20 9.5L11.5 18"
        stroke="#00D76B"
        stroke-width="2"
      />
    </svg>
  );
};

export default Arrow;
